// pages/ResetPassword.jsx
import React from "react";
import ResetPasswordForm from "../components/ResetPasswordForm";

export default function ResetPassword() {
  return (
      <ResetPasswordForm/>               
  );
}
